// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#retornos {
  font-family: "Open Sans", sans-serif;
}

.status span {
  padding: 5px 15px 5px 15px;
  border-radius: 20px;
  color: #999999;
  font-weight: 600;
}

.status .status-aprovado {
  background-color: rgba(0, 246, 255, 0.25);
}

.status .status-reprovado {
  background-color: rgba(229, 115, 115, 0.25);
}

.bandeira-cartao {
  margin: 0px;
  float: left;
}

.numero-cartao {
  margin: 0 10px 0 10px;
  font-weight: 800;
}

.validade-cartao {
  font-weight: 400;
}

thead .checkmark {
  top: -18px;
  left: 11px;
}

tbody .checkmark {
  top: -10px;
}

.checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -18px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e6e6e6;
}

.checkbox:hover input ~ .checkmark {
  background-color: #cccccc;
}

.checkbox input:checked ~ .checkmark {
  background-color: #22b7ff;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked ~ .checkmark:after {
  display: block;
}

.checkbox .checkmark:after {
  left: 8px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #e2e2e2;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.container-top {
  position: relative;
}

.container-top img {
  height: 30px;
  position: absolute;
}

.container-top .icon-search {
  left: 7px;
  top: 7px;
}

.container-top .icon-filter {
  position: relative;
  left: -40px;
  top: -3px;
}

.btn-registrar {
  margin-bottom: 30px;
}

.modal-content {
  border-radius: 5px;
}

.modal-header > .close {
  top: 23px;
}

.close {
  transition: 0.5s;
  font-size: 40px;
}

.inicio {
  margin: 20px;
}

.form-group {
  width: 200px;
  float: left;
  margin-right: 20px;
}

.input {
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 1px dashed #e2e2e2;
  border-radius: 6px;
  line-height: 38px;
  padding-left: 15px;
  transition: 0.5s;
  cursor: pointer;
  margin-left: 20px;
}

.input:hover {
  border: 1px dashed #00f6ff;
  transition: 0.5s;
}

.form-group .control-label {
  line-height: 17px;
  margin-left: 20px;
}

button {
  margin-top: 23px;
  float: left;
}

.file {
  display: none;
}

.dropdown {
  margin-left: 20px;
  float: left;
  width: 250px;
}
.dropdown label {
  font-size: 12px;
  color: #999999;
  width: 100%;
}
.dropdown button {
  position: relative;
  margin-top: 0px;
  border: solid 1px #e6e6e6;
  background-color: #fff;
  width: 100%;
  padding-left: 13px;
  text-align: left;
  font-size: 13px;
}
.dropdown button span {
  position: absolute;
  right: 15px;
  top: 17px;
}

.dropdown-menu {
  width: 100%;
}

.dropdown-menu:not(.head-list) > li > a {
  padding: 10px 20px;
  cursor: pointer;
}

.dropdown-toggle.btn-default {
  transition: 0.5s;
}

.dropdown-toggle.btn-default:hover, .dropdown-toggle.btn-default:focus {
  background-color: #fff;
  border: 1px solid #00f6ff;
  transition: 0.5s;
}

.dropdown.open > .btn {
  box-shadow: none;
}

.btn-registrar {
  margin-left: 20px;
}

.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}

@media only screen and (max-width: 1100px) {
  .pull-right {
    width: 100%;
    float: left !important;
  }
  .pull-right .dropdown {
    width: 100%;
    margin-left: 0;
    margin-right: 1.5%;
  }
  .pull-right .form-group {
    margin-top: 20px;
    width: 57%;
    margin-right: 0;
  }
  .pull-right .form-group label {
    margin-left: 0;
  }
  .pull-right .btn-registrar {
    width: 40%;
    margin-left: 1.5%;
    margin-top: 43px;
  }
}
@media only screen and (max-width: 550px) {
  .pull-right {
    width: 100%;
    float: left !important;
  }
  .pull-right .dropdown {
    width: 100%;
    margin-left: 0;
  }
  .pull-right .form-group {
    margin-top: 20px;
    width: 100%;
    margin-right: 0;
    margin-top: 15px;
    margin-bottom: 5px;
  }
  .pull-right .form-group label {
    margin-left: 0;
  }
  .pull-right .btn-registrar {
    width: 100%;
    margin-top: 10px;
    margin-left: 0;
  }
}
.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/boletos/retorno/retorno.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,oCCsCc;ADvClB;;AAIA;EACI,0BAAA;EACA,mBAAA;EACA,cCSQ;EDRR,gBAAA;AADJ;;AAIA;EACI,yCAAA;AADJ;;AAIA;EACI,2CAAA;AADJ;;AAIA;EACI,WAAA;EACA,WAAA;AADJ;;AAIA;EACI,qBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACC,UAAA;EACA,UAAA;AADD;;AAIA;EACC,UAAA;AADD;;AAIA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EAGH,iBAAA;AADD;;AAIA,wCAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AADJ;;AAIA,6BAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBClDQ;ADiDZ;;AAIA;EACI,yBCxDQ;ADuDZ;;AAIA;EACI,yBCvEO;ADsEX;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EAGA,wBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,YAAA;EACA,kBAAA;AADJ;;AAIA;EACI,SAAA;EACA,QAAA;AADJ;;AAIA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,sBCjII;EDkIJ,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADJ;;AAIA;EACI,0BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACI,eAAA;EACA,cC5KI;ED6KJ,WAAA;AADR;AAII;EACI,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBC7KA;ED8KA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAFZ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,sBCzMI;ED0MJ,yBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAMI;EACI,mBAAA;AAJR;;AAQA;EACI;IACI,WAAA;IACA,sBAAA;EALN;EAOM;IACI,WAAA;IACA,cAAA;IACA,kBAAA;EALV;EAQM;IACI,gBAAA;IACA,UAAA;IACA,eAAA;EANV;EAQU;IACI,cAAA;EANd;EAUM;IACI,UAAA;IACA,iBAAA;IACA,gBAAA;EARV;AACF;AAYA;EACI;IACI,WAAA;IACA,sBAAA;EAVN;EAYM;IACI,WAAA;IACA,cAAA;EAVV;EAaM;IACI,gBAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;EAXV;EAaU;IACI,cAAA;EAXd;EAeM;IACI,WAAA;IACA,gBAAA;IACA,cAAA;EAbV;AACF;AAiBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cCtSU;EDuSV,kBAAA;EACA,qBAAA;AAfF;AAgBE;EACE,iBAAA;AAdJ","sourcesContent":["@import '../../../../../../sass/variables';\n\n#retornos {\n    font-family: $fonte-open-sans;\n}\n\n.status span {\n    padding: 5px 15px 5px 15px;\n    border-radius: 20px;\n    color: $cinza-500;\n    font-weight: 600;\n}\n\n.status .status-aprovado {\n    background-color: rgba($azul-200, .25);\n}\n\n.status .status-reprovado {\n    background-color: rgba($danger, 0.25);\n}\n\n.bandeira-cartao {\n    margin: 0px;\n    float: left;\n}\n\n.numero-cartao {\n    margin: 0 10px 0 10px;\n    font-weight: 800;\n}\n\n.validade-cartao {\n    font-weight: 400;\n}\n\nthead .checkmark {\n\ttop: -18px;\n\tleft: 11px;\n}\n\ntbody .checkmark {\n\ttop: -10px;\n}\n\n.checkbox {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n\tuser-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.checkbox input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n}\n\n/* Create a custom checkbox */\n.checkmark {\n    position: absolute;\n    top: -18px;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: $cinza-200;\n}\n\n.checkbox:hover input ~ .checkmark {\n    background-color: $cinza-400;\n}\n\n.checkbox input:checked ~ .checkmark {\n    background-color: $azul-400;\n}\n\n.checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n\n.checkbox input:checked ~ .checkmark:after {\n    display: block;\n}\n\n.checkbox .checkmark:after {\n    left: 8px;\n    top: 5px;\n    width: 5px;\n    height: 10px;\n    border: solid $cinza-300;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n.container-top {\n    position: relative;\n}\n\n.container-top img {\n    height: 30px;\n    position: absolute;\n}\n\n.container-top .icon-search {\n    left: 7px;\n    top: 7px;\n}\n\n.container-top .icon-filter {\n    position: relative;\n    left: -40px;\n    top: -3px;\n}\n\n.btn-registrar {\n    margin-bottom: 30px;\n}\n\n.modal-content {\n    border-radius: 5px;\n}\n\n.modal-header > .close {\n    top: 23px;\n}\n\n.close {\n    transition: 0.5s;\n    font-size: 40px;\n}\n\n.inicio {\n    margin: 20px;\n}\n\n.form-group {\n    width: 200px;\n    float: left;\n    margin-right: 20px;\n}\n\n.input {\n    width: 100%;\n    height: 40px;\n    background-color: $white;\n    border: 1px dashed $cinza-300;\n    border-radius: 6px;\n    line-height: 38px;\n    padding-left: 15px;\n    transition: 0.5s;\n    cursor: pointer;\n    margin-left: 20px;\n}\n\n.input:hover {\n    border: 1px dashed $azul-200;\n    transition: 0.5s;\n}\n\n.form-group .control-label {\n    line-height: 17px;\n    margin-left: 20px;\n}\n\nbutton {\n    margin-top: 23px;\n    float: left;\n}\n\n.file {\n    display: none;\n}\n\n.dropdown {\n    margin-left: 20px;\n    float: left;\n    width: 250px;\n\n    label {\n        font-size: 12px;\n        color: $cinza-500;\n        width: 100%;\n    }\n\n    button {\n        position: relative;\n        margin-top: 0px;\n        border: solid 1px $cinza-200;\n        background-color: $white;\n        width: 100%;\n        padding-left: 13px;\n        text-align: left;\n        font-size: 13px;\n\n        span {\n            position: absolute;\n            right: 15px;\n            top: 17px;\n        }\n    }\n}\n\n.dropdown-menu {\n    width: 100%;\n}\n\n.dropdown-menu:not(.head-list) > li > a {\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\n.dropdown-toggle.btn-default {\n    transition: 0.5s;\n}\n\n.dropdown-toggle.btn-default:hover, .dropdown-toggle.btn-default:focus {\n    background-color: $white;\n    border: 1px solid $azul-200;\n    transition: 0.5s;\n}\n\n.dropdown.open > .btn {\n    box-shadow: none;\n}\n\n.btn-registrar {\n    margin-left: 20px;\n}\n\n.container-loading {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto;\n\n    .loading {\n        margin: 100px 0 0 0;\n    }\n}\n\n@media only screen and (max-width: 1100px) {\n    .pull-right {\n        width: 100%;\n        float: left !important;\n\n        .dropdown {\n            width: 100%;\n            margin-left: 0;\n            margin-right: 1.5%;\n        }\n\n        .form-group {\n            margin-top: 20px;\n            width: 57%;\n            margin-right: 0;\n\n            label {\n                margin-left: 0;\n            }\n        }\n\n        .btn-registrar {\n            width: 40%;\n            margin-left: 1.5%;\n            margin-top: 43px;\n        }\n    }\n}\n\n@media only screen and (max-width: 550px) {\n    .pull-right {\n        width: 100%;\n        float: left !important;\n\n        .dropdown {\n            width: 100%;\n            margin-left: 0;\n        }\n\n        .form-group {\n            margin-top: 20px;\n            width: 100%;\n            margin-right: 0;\n            margin-top: 15px;\n            margin-bottom: 5px;\n\n            label {\n                margin-left: 0;\n            }\n        }\n\n        .btn-registrar {\n            width: 100%;\n            margin-top: 10px;\n            margin-left: 0;\n        }\n    }\n}\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
